import { http } from "../client";
export var deleteGenre = function (id) { return http.api.delete("genres/" + id); };
